import { Layout } from '@/components/layout';
import { PublicOutlet } from '@/outlets/public-outlet';
import { ForgotPasswordPage } from '@/pages/auth/forgot-password/forgot-password-page';
import { ForgotPasswordSuccessPage } from '@/pages/auth/forgot-password/forgot-password-success-page';
import { LoginPage } from '@/pages/auth/login/login-page';
import { RegisterPage } from '@/pages/auth/register/register-page';
import { RegisterExternalPatientPage } from '@/pages/auth/register/register-external-patient-page';
import { ResetPasswordPage } from '@/pages/auth/reset-password/reset-password-page';
import { ResetPasswordSuccessPage } from '@/pages/auth/reset-password/reset-password-success-page';
import { UsernameRestorationPage } from '@/pages/auth/username-restoration/username-restoration-page';
import { UsernameRestorationSuccessPage } from '@/pages/auth/username-restoration/username-restoration-success-page';
import { Route } from '@/util/react-router-dom';

export const guestOnlyRoutes = (
  <Route element={<PublicOutlet />}>
    <Route element={<Layout />}>
      <Route path="login" element={<LoginPage />} />
      <Route path="register" element={<RegisterPage />} />
      <Route path="register-external-patient/:seedKey" element={<RegisterExternalPatientPage />} />
      <Route path="forgot-password">
        <Route index element={<ForgotPasswordPage />} />
        <Route path="success" element={<ForgotPasswordSuccessPage />} />
      </Route>
      <Route path="reset-password">
        <Route index element={<ResetPasswordPage />} />
        <Route path="success" element={<ResetPasswordSuccessPage />} />
      </Route>
      <Route path="restore-usernames">
        <Route index element={<UsernameRestorationPage />} />
        <Route path="success" element={<UsernameRestorationSuccessPage />} />
      </Route>
    </Route>
  </Route>
);
